import type { FC } from 'react';
import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { cssMap, cx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	overlayCSS: {
		width: '100%',
		height: '100%',
	},
	overlayLoading: {
		opacity: token('opacity.loading'),
		pointerEvents: 'none',
		cursor: 'not-allowed',
	},
});

/**
 * LoadingOverlay displays when the loading prop is true.
 * It is used to prevent the user from interacting with the component when the loading prop is true.
 */
export const LoadingOverlay: FC<{ loading: boolean; children?: React.ReactNode }> = ({
	loading,
	children,
}) => (
	<Box
		xcss={cx(styles.overlayCSS, loading && styles.overlayLoading)}
		data-vc="content-tree-search-overlay"
	>
		{children}
	</Box>
);
